import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from "@angular/forms";
import { Subject, takeUntil } from 'rxjs';
import { ODataService } from '@ui-kit/odata';


@Component({
  selector: 'patient-appointment-create',
  templateUrl: './appointment-create.html'
})
export class PatientAppointmentCreateComponent implements OnDestroy {

  @Output() appointmentAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() appointmentCanceled: EventEmitter<any> = new EventEmitter<any>();

  public form: FormGroup | undefined = undefined;
  public errMessage: string = '';

  private isSaving = false;
  private readonly unsubscribe$ = new Subject<void>();
  public intervalCounter = 0;
  private interval: any = null;


  @Input() patientDetails: any;
  @Input() set selectedAppointment(value: any) {
    this.errMessage = '';

    if (!value) {
      this.form = undefined;
      return;
    }

    this.clearCounter();
    this.interval = setInterval(() => this.intervalCounter++, 1000);

    value.dateAndTime = `${value.date}, ${value.combinedTime}`;

    this.form = new FormGroup({
      medicalAppointmentQueueId: new FormControl(value.id),
      patientId: new FormControl(this.patientDetails?.id),

      lastName: new FormControl(this.patientDetails?.lastName),
      firstName: new FormControl(this.patientDetails?.firstName),
      patronymic: new FormControl(this.patientDetails?.patronymic),
      phone1: new FormControl(this.patientDetails?.phone1),
      doctorAndSpecialty: new FormControl({value: value.doctorAndSpecialty, disabled: true}),
      dateAndTime: new FormControl({value: value.dateAndTime, disabled: true}),
      comment: new FormControl(),
    });
  }


  constructor(private odata: ODataService) { }


  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    this.clearCounter();
  }


  public save(): void {
    if (!this.form) {
      return;
    }
    
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.isSaving) { return; }
    this.isSaving = true;
    this.errMessage = '';

    this.odata.post('patientAppointments', { params: { action: "create" }, body: this.form.value })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({ 
        next: (xx: any) => {

          sessionStorage.setItem('patient.id', xx.masterId); // use sessionStorage - while development - to work with prev-saved patient
          this.isSaving = false;
          this.appointmentAdded.emit(xx.id);

          this.clearCounter();
        }, 
        error: (e) => {
          this.isSaving = false;

          this.errMessage = this.getErrorMessage(e);
        } 
      });

  }

  public cancel = () => { 
    const medicalAppointmentQueueId = this.form?.value?.medicalAppointmentQueueId;

    if (medicalAppointmentQueueId) {
      this.form = undefined; 
      this.clearCounter(); 

      this.odata.post(`patientAppointments/unReserve?id=${medicalAppointmentQueueId}`, { params: { }, body: {} })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => this.appointmentCanceled.emit())
    }
  }


  private clearCounter = () => { clearInterval(this.interval); this.intervalCounter = 0; };

  private getErrorMessage(e: any): string {
    let errMessage = (e?.error?.error?.message ?? 'Помилка збереження даних').trim(); 

    switch (errMessage) {
      case 'existingNextAppointmentsCount':
        return 'Ваш запис відхилено. Перевищено максимальну кількість записів онлайн.';
      case 'appointmentIsEngaged':
        return 'Запис вже недоступний. Оберіть інший час.';
      default:
        return 'Помилка збереження даних';
    }
  }
}
